import React from 'react';

import { Container } from '@soluto-design/react';
import YoutubeVideo, { YoutubeVideoProps } from '../../atoms/YoutubeVideo';

export interface MediaFullSectionProps {
    video: YoutubeVideoProps;
}

const MediaFullSection = ({ video }: MediaFullSectionProps) => {
    return (
        <section className="my-xxxl">
            <Container>
                <YoutubeVideo
                    {...video}
                    className="rounded-large overflow-hidden"
                    showTitle
                    startOnClick
                />
            </Container>
        </section>
    );
};

export default MediaFullSection;
